import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { fmtMin } from "@/pages/StudyPlan";

const STATUS = { fit: ["Waktu cukup", "bg-sage-soft text-sage"], tight: ["Ketat", "bg-amber-100 text-amber-800"], over: ["Tidak cukup", "bg-primary/10 text-primary"], past: ["Tanggal lewat", "bg-muted text-muted-foreground"] };

export function ExamPlanCard({ className = "" }) {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/study-plan").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const st = p.status ? STATUS[p.status] : null;
  const thisWeek = p.weeks?.find((w) => { const d = new Date().toISOString().slice(0, 10); return w.start <= d && d <= w.end; });
  return (
    <div className={`soft-card p-6 ${className}`} data-testid="exam-plan-card">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2 text-xs uppercase tracking-wide text-muted-foreground"><CalendarDays className="h-3.5 w-3.5" />Rencana ujian JLPT</div>
        {st && <span data-testid="exam-plan-status" className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${st[1]}`}>{st[0]}</span>}
      </div>
      {p.exam_date ? (
        <>
          <p className="mt-3 font-jpserif text-3xl" data-testid="exam-plan-days">{p.days_left} <span className="text-base text-muted-foreground">hari lagi · {p.target_level}</span></p>
          <p className="mt-1 text-sm text-muted-foreground">Butuh ≈ <b className="text-foreground">{p.required_per_day} mnt/hari</b> ({p.prefs.days_per_week} hari/minggu) · tersedia {p.prefs.minutes_per_day} mnt/hari · sisa {fmtMin(p.required_minutes)} untuk {p.modules_remaining} tahap.</p>
          {thisWeek && <p className="mt-2 text-xs text-muted-foreground" data-testid="exam-plan-week">Minggu ini: {thisWeek.modules.length} tahap · {fmtMin(thisWeek.minutes)} — {thisWeek.modules.slice(0, 4).map((m) => m.code).join(", ")}{thisWeek.modules.length > 4 ? ", …" : ""}</p>}
        </>
      ) : (
        <p className="mt-3 text-sm text-muted-foreground">Belum ada tanggal ujian. Dengan {p.prefs.minutes_per_day} mnt × {p.prefs.days_per_week} hari/minggu, semua tahap ({fmtMin(p.required_minutes)}) selesai dalam ≈ {p.weeks_needed} minggu.</p>
      )}
      <Link data-testid="exam-plan-link" to="/study-plan" className="mt-3 inline-flex min-h-[40px] items-center gap-2 text-xs font-medium underline-offset-4 hover:underline">{p.exam_date ? "Lihat jadwal mingguan & sesuaikan" : "Atur tanggal ujian"}<ArrowRight className="h-3 w-3" /></Link>
    </div>
  );
}
